// Schema and mapper for Salesforce Project_Page_Component__c

export function fromSalesforceProjectPageComponent(sfRecord) {
  const data = {
    info: {
      name: "",
      projectPageId: "",
      projectPageName: "",
      projectPageType: "",
      projectName: "",
      projectObjective: "",
      recordTypeId: "",
      recordTypeName: "",
      ppcType: "",
      componentOrder: "",
    },
    content: {
      headline1: "",
      headline2: "",
      headline3: "",
      textArea1: "",
      textArea2: "",
      textArea3: "",
      imageLocation1: "",
      imageLocation2: "",
      imageLocation3: "",
      buttonType1: "",
      buttonType2: "",
      buttonType3: "",
      buttonName1: "",
      buttonName2: "",
      buttonName3: "",
      buttonUrl1: "",
      buttonUrl2: "",
      buttonUrl3: "",
      fileUrl1: "",
      fileUrl2: "",
      fileUrl3: "",
    },
    sys: {
      createdById: "",
      lastModifiedById: "",
    },
  };

  if (!sfRecord || typeof sfRecord !== "object") return { id: null, ...data };

  // Info
  data.info.name = sfRecord.Name || "";
  data.info.projectPageId =
    (sfRecord.Project_Page__r && sfRecord.Project_Page__r.Id) ||
    sfRecord.Project_Page__c ||
    "";
  data.info.projectPageName =
    (sfRecord.Project_Page__r && sfRecord.Project_Page__r.Name) || "";
  data.info.projectPageType = sfRecord.Project_Page_Type__c || "";
  data.info.projectName = sfRecord.Project_Name__c || "";
  data.info.projectObjective = sfRecord.Project_Objective__c || "";
  data.info.recordTypeId = sfRecord.RecordTypeId || "";
  const recordTypeName =
    (sfRecord && sfRecord.RecordType && sfRecord.RecordType.Name) ||
    sfRecord.RecordTypeName ||
    "";
  data.info.recordTypeName = recordTypeName;
  // Prefer Record Type Name as the canonical PPC type label
  data.info.ppcType = recordTypeName || data.info.name || "";
  data.info.componentOrder = sfRecord.Component_Order__c ?? "";

  // Content
  data.content.headline1 = sfRecord.Headline_1__c || "";
  data.content.headline2 = sfRecord.Headline_2__c || "";
  data.content.headline3 = sfRecord.Headline_3__c || "";
  data.content.textArea1 = sfRecord.Text_Area_1__c || "";
  data.content.textArea2 = sfRecord.Text_Area_2__c || "";
  data.content.textArea3 = sfRecord.Text_Area_3__c || "";
  data.content.imageLocation1 = sfRecord.Image_Location_1__c || "";
  data.content.imageLocation2 = sfRecord.Image_Location_2__c || "";
  data.content.imageLocation3 = sfRecord.Image_Location_3__c || "";
  data.content.buttonType1 = sfRecord.Button_Type__c || "";
  data.content.buttonType2 = sfRecord.Button_Type_2__c || "";
  data.content.buttonType3 = sfRecord.Button_Type_3__c || "";
  data.content.buttonName1 = sfRecord.Button_Name_1__c || "";
  data.content.buttonName2 = sfRecord.Button_Name_2__c || "";
  data.content.buttonName3 = sfRecord.Button_Name_3__c || "";
  data.content.buttonUrl1 = sfRecord.Button_URL_1__c || "";
  data.content.buttonUrl2 = sfRecord.Button_URL_2__c || "";
  data.content.buttonUrl3 = sfRecord.Button_URL_3__c || "";
  data.content.fileUrl1 = sfRecord.File_Download_URL_1__c || "";
  data.content.fileUrl2 = sfRecord.File_Download_URL_2__c || "";
  data.content.fileUrl3 = sfRecord.File_Download_URL_3__c || "";
  // System
  data.sys.createdById = sfRecord.CreatedById || "";
  data.sys.lastModifiedById = sfRecord.LastModifiedById || "";

  const id = sfRecord.Id || null;
  return { id, ...data };
}

// Mapper for PATCH/UPDATE to Salesforce fields
export function toSalesforceProjectPageComponent(uiRecord) {
  const rec = {};
  if (!uiRecord || typeof uiRecord !== "object") return rec;
  const info = uiRecord.info || {};
  const content = uiRecord.content || {};
  if (uiRecord.id) rec.Id = uiRecord.id;
  if (info.name !== undefined) rec.Name = info.name || null;
  if (info.projectPageId !== undefined)
    rec.Project_Page__c = info.projectPageId || null;
  if (info.projectPageType !== undefined)
    rec.Project_Page_Type__c = info.projectPageType || null;
  if (info.recordTypeId !== undefined)
    rec.RecordTypeId = info.recordTypeId || null;
  if (info.componentOrder !== undefined)
    rec.Component_Order__c = info.componentOrder || null;
  // Content
  if (content.headline1 !== undefined)
    rec.Headline_1__c = content.headline1 || null;
  if (content.headline2 !== undefined)
    rec.Headline_2__c = content.headline2 || null;
  if (content.headline3 !== undefined)
    rec.Headline_3__c = content.headline3 || null;
  if (content.textArea1 !== undefined)
    rec.Text_Area_1__c = content.textArea1 || null;
  if (content.textArea2 !== undefined)
    rec.Text_Area_2__c = content.textArea2 || null;
  if (content.textArea3 !== undefined)
    rec.Text_Area_3__c = content.textArea3 || null;
  if (content.imageLocation1 !== undefined)
    rec.Image_Location_1__c = content.imageLocation1 || null;
  if (content.imageLocation2 !== undefined)
    rec.Image_Location_2__c = content.imageLocation2 || null;
  if (content.imageLocation3 !== undefined)
    rec.Image_Location_3__c = content.imageLocation3 || null;
  if (content.buttonType1 !== undefined)
    rec.Button_Type__c = content.buttonType1 || null;
  if (content.buttonType2 !== undefined)
    rec.Button_Type_2__c = content.buttonType2 || null;
  if (content.buttonType3 !== undefined)
    rec.Button_Type_3__c = content.buttonType3 || null;
  if (content.buttonName1 !== undefined)
    rec.Button_Name_1__c = content.buttonName1 || null;
  if (content.buttonName2 !== undefined)
    rec.Button_Name_2__c = content.buttonName2 || null;
  if (content.buttonName3 !== undefined)
    rec.Button_Name_3__c = content.buttonName3 || null;
  if (content.buttonUrl1 !== undefined)
    rec.Button_URL_1__c = content.buttonUrl1 || null;
  if (content.buttonUrl2 !== undefined)
    rec.Button_URL_2__c = content.buttonUrl2 || null;
  if (content.buttonUrl3 !== undefined)
    rec.Button_URL_3__c = content.buttonUrl3 || null;
  if (content.fileUrl1 !== undefined)
    rec.File_Download_URL_1__c = content.fileUrl1 || null;
  if (content.fileUrl2 !== undefined)
    rec.File_Download_URL_2__c = content.fileUrl2 || null;
  if (content.fileUrl3 !== undefined)
    rec.File_Download_URL_3__c = content.fileUrl3 || null;
  return rec;
}
